// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.link--active[data-v-67479d4a] {\n  color: var(--v-primary-base);\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
